import React from "react";

export function Button({
  children, onClick, disabled, loading, variant = "primary",
  icon, testID, style, type = "button", fullWidth = true,
}) {
  const isSecondary = variant === "secondary";
  const isDanger = variant === "danger";
  const bg = isDanger ? "var(--mf-urgent-solid)" : isSecondary ? "var(--mf-bg-card)" : "var(--mf-brand)";
  const color = isSecondary ? "var(--mf-brand)" : "#fff";
  const border = isSecondary ? "1px solid var(--mf-border)" : "none";
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      data-testid={testID}
      style={{
        display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8,
        padding: "13px 22px", borderRadius: 999,
        background: bg, color, border,
        fontSize: 15, fontWeight: 700, cursor: disabled || loading ? "not-allowed" : "pointer",
        opacity: disabled || loading ? 0.6 : 1,
        transition: "transform 150ms, opacity 150ms",
        width: fullWidth ? "100%" : "auto",
        ...style,
      }}
      onMouseDown={(e) => { if (!disabled && !loading) e.currentTarget.style.transform = "scale(0.98)"; }}
      onMouseUp={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
    >
      {loading ? (
        <span style={{
          width: 16, height: 16, border: "2px solid rgba(255,255,255,0.3)",
          borderTopColor: color, borderRadius: "50%",
          animation: "mf-spin 700ms linear infinite",
        }} />
      ) : (
        <>
          {icon}
          <span>{children}</span>
        </>
      )}
      <style>{`@keyframes mf-spin { to { transform: rotate(360deg); } }`}</style>
    </button>
  );
}

export function Field({
  label, value, onChange, placeholder, type = "text", testID,
  autoComplete, autoCapitalize, maxLength, multiline, style, error, hint,
}) {
  const commonProps = {
    value: value || "",
    onChange: (e) => onChange(e.target.value),
    placeholder,
    "data-testid": testID,
    autoComplete,
    autoCapitalize,
    maxLength,
    style: {
      width: "100%", padding: "12px 14px", borderRadius: 12,
      background: "var(--mf-bg-card)", border: `1px solid ${error ? "var(--mf-urgent-solid)" : "var(--mf-border)"}`,
      color: "var(--mf-text)", fontSize: 15, fontFamily: "inherit",
      outline: "none", transition: "border-color 150ms",
      ...style,
    },
  };
  return (
    <div style={{ marginBottom: 14 }}>
      {label && (
        <label style={{
          display: "block", fontSize: 13, fontWeight: 600,
          color: "var(--mf-text-secondary)", marginBottom: 6,
        }}>
          {label}
        </label>
      )}
      {multiline ? (
        <textarea {...commonProps} rows={4} style={{ ...commonProps.style, resize: "vertical", minHeight: 90 }} />
      ) : (
        <input type={type} {...commonProps} />
      )}
      {error && (
        <div style={{ marginTop: 6, fontSize: 12, color: "var(--mf-urgent-text)" }}>{error}</div>
      )}
      {!error && hint && (
        <div style={{ marginTop: 6, fontSize: 12, color: "var(--mf-text-muted)" }}>{hint}</div>
      )}
    </div>
  );
}

export function IconButton({ icon, onClick, testID, ariaLabel, style }) {
  return (
    <button
      onClick={onClick}
      data-testid={testID}
      aria-label={ariaLabel}
      style={{
        width: 40, height: 40, borderRadius: 20,
        display: "inline-flex", alignItems: "center", justifyContent: "center",
        background: "var(--mf-bg-muted)", border: "none", color: "var(--mf-text)",
        cursor: "pointer", transition: "background 150ms",
        ...style,
      }}
      onMouseEnter={(e) => { e.currentTarget.style.background = "var(--mf-border)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = "var(--mf-bg-muted)"; }}
    >
      {icon}
    </button>
  );
}
